import { WorkOrderItemData } from '..';
import { useDisclosure } from '@/hooks';
import { useWorkorderDetailContext } from '../../../WorkorderDetailProvider';
import { WorkOrderComplementStatus } from '@/core/domain/workorder/WorkOrdersComplements/WorkOrdersComplements.types';
import { Divider, Popover } from 'antd';
import { WorkOrderItemType } from '@/core/domain/workorder/WorkOrdersItems/WorkOrdersItems.types';
import ActionIcon from '@/components/_common/ActionIcon';
import { Plus } from 'react-feather';
import WorkOrderItemModal from '../../WorkOrderItemModal';

interface Props {
  workOrderItem: WorkOrderItemData;
  refetchItems: VoidFunction;
}

export default function WorkOrderItemAddKit({
  workOrderItem,
  refetchItems,
}: Props) {
  const [modalOpened, modalAction] = useDisclosure();

  const {
    complement: { data: complement },
  } = useWorkorderDetailContext();

  const isClosed = complement?.status === WorkOrderComplementStatus.Closed;

  if (isClosed || workOrderItem.type !== WorkOrderItemType.Kit) return null;

  return (
    <>
      <Divider type="vertical" />

      <Popover content="Adicionar item ao kit">
        <div>
          <ActionIcon onClick={modalAction.open}>
            <Plus size={20} />
          </ActionIcon>
        </div>
      </Popover>

      {!!workOrderItem.kitName && workOrderItem.kitId && (
        <WorkOrderItemModal
          open={modalOpened}
          onCancel={modalAction.close}
          onFinish={() => {
            modalAction.close();
            refetchItems();
          }}
          kit={{ name: workOrderItem.kitName, id: workOrderItem.kitId }}
        />
      )}
    </>
  );
}
